import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnCountdownComponent } from './dn-countdown.component';

@NgModule({
  declarations: [DnCountdownComponent],
  exports: [DnCountdownComponent],
  imports: [CommonModule],
})
export class DnCountdownModule {}
